import { render } from "./UserSearchBar.vue?vue&type=template&id=70e1ba2b&scoped=true"
import script from "./UserSearchBar.vue?vue&type=script&lang=js"
export * from "./UserSearchBar.vue?vue&type=script&lang=js"

import "./UserSearchBar.vue?vue&type=style&index=0&id=70e1ba2b&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e1ba2b"]])

export default __exports__